import * as stylex from '@stylexjs/stylex';
import { forwardRef, type AriaRole } from 'react';
export interface IconProps extends React.ComponentProps<'svg'> {
  focusable?: boolean;
  role?: AriaRole;
  title: string;
  description: string;
  children?: React.ReactNode;
  layout?: 'fill' | 'contain';
  viewBox?: string;
  styles?: stylex.StyleXStyles;
  size?: stylex.StyleXStyles<{
    height?: string;
    width?: string;
  }>;
}
export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon({
  viewBox = '0 0 48 48',
  focusable,
  children,
  role,
  title,
  description,
  layout,
  size,
  styles,
  ...props
}, ref) {
  function toCamelCase(string: string) {
    return string.replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()).replace(/\s+/g, '');
  }
  const titleId = title && toCamelCase(title);
  const descId = description && titleId + 'Desc';
  const ariaLabelledById = titleId && `${titleId}${descId ? ` ${descId}` : ``}`;
  const objectFit = layout === 'fill' ? 'xMidYMid slice' : 'xMidYMid meet';
  return <svg xmlns="http://www.w3.org/2000/svg" ref={ref} role={role || 'img' as AriaRole} aria-labelledby={ariaLabelledById} preserveAspectRatio={objectFit} viewBox={viewBox} {...stylex.props([size, styles])} {...props}>
      {title && <title id={titleId}>{title}</title>}
      {description && <desc id={descId}>{description}</desc>}
      {children}
    </svg>;
});